const BaseModel = require('lib/base_model')
const log = require('log').create('model','role') // eslint-disable-line

const Role = BaseModel.extend({

    idAttribute: 'lowercase_role',

    defaults: {
        role: '',
    },

     
    constructor: function constructor(attrs, options) {
        // generate initial idAttribute value
        attrs[this.idAttribute] = this.generateId(attrs.role)
        return BaseModel.apply(this, [attrs, options])
    },

    initialize() {
        // for safety, don't think roles actually change
        this.on('change:role', (model, role) => {
            this.set(this.idAttribute, this.generateId(role))
        })
    },

    generateId(role) {
        return (
            (role || '')
                .toLowerCase()
                .trim()
                .replace(/ /g, '_')
        )
    },

    calculated_values: {
        lowercase() {
            const role = this.get('role') || ''
            return role.toLowerCase()
        },
    },

    // override model.set to sanitize input
    set() {
        const { attrs, options } = this.parseKeyValArguments.apply(this, arguments)

        if (attrs.role) {
            attrs.role = this.sanitize(attrs.role)
        }

        BaseModel.prototype.set.apply(this, [attrs, options])
    },

    sanitize(value) {
        return (
            value
            // only alphanumeric, _, /, and -
                .replace(/[^a-z0-9À-ž_-\s/]+/ig, '')
            // no double dashes or hypens or hyphen dashes or dash hyphens
                .replace(/[-|_](?=-|_)/g, '')
        )
    },

})

module.exports = Role
